export default __webpack_public_path__ + "static/media/logo.a099a387.png";